import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ACMain } from "./elixir/ACMain";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ACMain />
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.querySelector("#app"));
